<template>
  <wo-layout>
    <po-error-display :value="error" mod-scroll />
    <form autocomplete="off">
      <wo-grid>
        <wo-column width-md="7">
          <wo-card :title="$t('general.info')">
            <wo-properties mod-horizontal mod-bordered v-focus="true">
              <wo-properties-label><wo-label><span v-t="'company.name'" />*</wo-label></wo-properties-label>
              <wo-properties-value><po-input-field name="name" v-model="pending.company.name" messageKey="salespoint.nameInfo"/></wo-properties-value>
              <wo-properties-label><wo-label v-t="'company.website'" /></wo-properties-label>
              <wo-properties-value><po-input-field name="website" v-model="pending.company.website" /></wo-properties-value>
              <wo-properties-label><wo-label v-t="'company.email'" /></wo-properties-label>
              <wo-properties-value><po-input-field name="email" v-model="pending.company.email" /></wo-properties-value>
              <wo-properties-label><wo-label v-t="'company.phoneNumber'" /></wo-properties-label>
              <wo-properties-value><po-input-field name="phoneNumber" v-model="pending.company.phone_number" /></wo-properties-value>

              <wo-properties-label><wo-label v-t="'salespoint.externalId'" /></wo-properties-label>
              <wo-properties-value><po-input-field name="externalId" v-model="pending.external_id" messageKey="salespoint.externalIdInfo" /></wo-properties-value>
            </wo-properties>
          </wo-card>
          <wo-spacer />
          <wo-card :title="$t('salespoint.flags')">
            <wo-properties mod-horizontal mod-bordered>
              <wo-properties-label><wo-label><span v-t="'salespoint.channel'" />*</wo-label></wo-properties-label>
              <wo-properties-value><po-selector v-if="channels" :options="channels" v-model="pending.channel" :label-factory="createChannelLabel" /></wo-properties-value>

              <template v-for="(group, i) in pendingTags">
                <wo-properties-label :key="group.type.id"><wo-label><po-display :value="group.type" /></wo-label></wo-properties-label>
                <wo-properties-value :key="i">
                  <po-selector v-model="group.values" :multiple="true" :options="group.options" @input="onTagUpdate" />
                </wo-properties-value>
              </template>

              <wo-properties-label><wo-label v-t="'salespoint.published'" /></wo-properties-label>
              <wo-properties-value>
                <wo-checkbox v-model="pending.published" mod-block><span v-t="'salespoint.published'"></span></wo-checkbox>
              </wo-properties-value>
              <wo-properties-label><wo-label v-t="'salespoint.garageConcept'" /></wo-properties-label>
              <wo-properties-value>
                <wo-checkbox v-model="pending.garage_concept" mod-block><span v-t="'salespoint.garageConcept'"></span></wo-checkbox>
              </wo-properties-value>

            </wo-properties>
          </wo-card>
          <wo-spacer />
        </wo-column>
        <wo-column width-md="5">
          <address-lookup v-model="pending.company.address" :address-name="pending.company.name" :mod-focus="!newEntity" />
        </wo-column>
      </wo-grid>
      <po-confirmation-buttons @confirm="confirm" @cancel="emitCancel" :valid="valid" />
    </form>
  </wo-layout>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import editor from '@/mixins/editor'

import { SalesPoint, SalesPointTag, SalesPointChannelEnum } from '@/model/sales-point'
import { Company, SegmentEnum } from '@/model/company'

import { salesPointRepository, salesPointTagRepository } from '@/repository/sales-point'
import { enumerationRepository } from '@/repository/enumeration'

import AddressLookup from '@/components/geography/AddressLookup'

export default {
  mixins: [ editor ],
  components: { AddressLookup },
  props: {
    value: SalesPoint,
    relatedCompany: Company,
    tags: Array
  },
  data () {
    return {
      pendingTags: undefined,
      tagsUpdated: false
    }
  },
  computed: mapState({
    channels: state => state.enumeration[SalesPointChannelEnum.id],
    segments: state => state.enumeration[SegmentEnum.id],
    valid () {
      const c = this.pending
      return c.company.name && c.channel && (c.brand || !this.newEntity)
    }
  }),
  watch: {
    tags () { this.groupTags() }
  },
  created () {
    this.pending = new SalesPoint(this.value)
    this.pending.related_company = this.relatedCompany

    this.$store.dispatch(enumerationRepository.find, SalesPointChannelEnum)
    this.$store.dispatch(enumerationRepository.find, SegmentEnum)
      .then(this.groupTags)
  },
  methods: {
    createChannelLabel: (c) => c.audience ? `${c.name} (${c.audience.name})` : c.name,
    confirm ({ detail }) {
      const action = this.newEntity ? salesPointRepository.create : salesPointRepository.update
      this.$store.dispatch(action, { entity: this.pending })
        .then(salesPoint => {
          if (this.tagsUpdated) {
            return this.confirmTags(salesPoint)
          } else {
            return salesPoint
          }
        })
        .then(this.emitInput, this.editFailed)
        .finally(detail.resolve)
    },
    groupTags () {
      this.pendingTags = _.map(SalesPointTag.grouped(this.tags), group => {
        if (group.type.enum === SegmentEnum) {
          group.options = this.segments
        } else {
          group.options = group.type.enum.values
        }
        return group
      })
    },
    confirmTags (salesPoint) {
      const entities = _.flatten(_.map(this.pendingTags, group => {
        return _.map(group.values, v => SalesPointTag.for(group.type, v))
      }))
      return this.$store.dispatch(salesPointTagRepository.updateAll, { salesPointId: salesPoint.id, entities })
        .then(() => salesPoint)
    },
    onTagUpdate () {
      this.tagsUpdated = true
    }
  }
}
</script>
